import { ActionTypes } from '../../constants/ActionTypes';
import { IConfirm, IRemoveConfirm } from '../../interfaces';
import {
  IGetSecretariatArgs,
  ILetterSignatureAccess,
  IRetriveLetter,
  ISaveAndSignLetter,
} from '../../interfaces/Signature';

export const onGetSignatureList = (action: IGetSecretariatArgs) => {
  return {
    type: ActionTypes.GET_SIGNATURE_LIST,
    payload: {
      letterCode: action.letterCode,
      secretariatToSecretariatFormatId: action.secretariatToSecretariatFormatId,
      signIndex: action.signIndex,
      search: action.search,
    },
  };
};

export const checkCanConfirmLetter = (action: ILetterSignatureAccess) => {
  return {
    type: ActionTypes.CHECK_CAN_CONFIRM_LETTER,
    payload: {
      letterCode: action.letterCode,
      signatureIndex: action.signatureIndex,
    },
  };
};

export const checkCanConfirmLetterSuccess = (hasAccess: boolean) => {
  return {
    type: ActionTypes.CHECK_CAN_CONFIRM_LETTER_SUCCESS,
    payload: hasAccess,
  };
};

export const fetchSignatureListSuccess = (signatureList: any[]) => {
  return {
    type: ActionTypes.FETCH_SIGNATURE_LIST_SUCCESS,
    payload: signatureList,
  };
};

export const onSignLetter = (action: ISaveAndSignLetter) => {
  return {
    type: ActionTypes.SIGN_LETTER,
    payload: action,
  };
};

export const onSignLetterSuccess = () => {
  return {
    type: ActionTypes.SIGN_LETTER_SUCCESS,
  };
};

export const onConfirmLetter = (action: IConfirm) => {
  return {
    type: ActionTypes.CONFIRM_LETTER,
    payload: action,
  };
};

export const onConfirmLetterSuccess = () => {
  return {
    type: ActionTypes.CONFIRM_LETTER_SUCCESS,
  };
};

export const onRemoveConfirmLetter = (action: IRemoveConfirm) => {
  return {
    type: ActionTypes.REMOVE_CONFIRM_LETTER,
    payload: action,
  };
};

export const onRemoveConfirmLetterSuccess = (action: any) => {
  return {
    type: ActionTypes.REMOVE_CONFIRM_LETTER_SUCCESS,
    payload: action.data,
  };
};

export const onRetriveLetter = (action: IRetriveLetter) => {
  return {
    type: ActionTypes.RETRIVE_LETTER,
    payload: action,
  };
};

export const onRetriveLetterSuccess = () => {
  return {
    type: ActionTypes.RETRIVE_LETTER_SUCCESS,
  };
};

export const onClearSignatureState = () => {
  return {
    type: ActionTypes.ClearSignatureState,
  };
};
